import { render, staticRenderFns } from "./UserSettingsConnections.vue?vue&type=template&id=f130fd38"
import script from "./UserSettingsConnections.vue?vue&type=script&lang=js"
export * from "./UserSettingsConnections.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsConnections.vue?vue&type=style&index=0&id=f130fd38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports